import { render, staticRenderFns } from "./EvolutionPercentageChart.vue?vue&type=template&id=5e54a2dc&scoped=true"
import script from "./EvolutionPercentageChart.vue?vue&type=script&lang=js"
export * from "./EvolutionPercentageChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e54a2dc",
  null
  
)

export default component.exports